<app-breadcrumb [title]="'Evaluación de Comportamiento SV'" [items]="['Responsabilidad y Comportamiento Seguro']"
    [active_item]="'Evaluación de Comportamiento'"></app-breadcrumb>

<div class="container-fluid programa-form-wrap">
    <div class="card shadow-sm border-0">
        <div class="card-header bg-primary text-white d-flex align-items-center">
            <i class="icofont icofont-clipboard me-2"></i>
            <h5 class="mb-0"><strong>EVALUACIÓN DE COMPORTAMIENTO EN SEGURIDAD VIAL</strong></h5>
        </div>

        <div class="card-body">
            <ul ngbNav #evaluacionTab="ngbNav" [(activeId)]="activeTab" class="nav-tabs">

                <!-- ===================== TAB 1: FORMULARIO ===================== -->
                <li [ngbNavItem]="1">
                    <a ngbNavLink><strong><i class="icofont icofont-plus me-1"></i> EVALUAR</strong></a>
                    <ng-template ngbNavContent>
                        <form [formGroup]="evaluacionForm" (ngSubmit)="guardar()" class="pt-3" novalidate>

                            <!-- Datos generales -->
                            <div class="card border-0 shadow-sm mb-3">
                                <div class="card-body">
                                    <div class="row g-3">
                                        <div class="col-md-5">
                                            <label class="form-label fw-semibold">
                                                <i class="icofont icofont-business-man me-1"></i>Colaborador: <span
                                                    class="text-danger">*</span></label>
                                            <ng-select [items]="colaboradores" bindLabel="nombreCompleto"
                                                bindValue="cedula" [compareWith]="compararPorCedula"
                                                [loading]="cargandoColaboradores"
                                                placeholder="Seleccione el colaborador..."
                                                formControlName="cedula_colaborador">
                                            </ng-select>
                                        </div>

                                        <div class="col-md-2">
                                            <label class="form-label fw-semibold">
                                                <i class="icofont icofont-calendar me-1"></i>Periodo: <span
                                                    class="text-danger">*</span></label>
                                            <input type="number" class="form-control" formControlName="periodo"
                                                [readonly]="modoEdicion">
                                        </div>

                                        <div class="col-md-2">
                                            <label class="form-label fw-semibold">
                                                <i class="icofont icofont-ui-calendar me-1"></i>Fecha evaluación: <span
                                                    class="text-danger">*</span></label>
                                            <input type="date" class="form-control" formControlName="fecha_evaluacion">
                                        </div>

                                        <div class="col-md-3">
                                            <label class="form-label fw-semibold"><i class="icofont icofont-id-card me-1"></i>Evaluador:</label>
                                            <ng-select [items]="colaboradores" bindLabel="nombreCompleto"
                                                bindValue="cedula" [compareWith]="compararPorCedula"
                                                placeholder="Seleccione el evaluador..." formControlName="evaluador">
                                            </ng-select>
                                        </div>

                                        <div class="col-md-12">
                                            <label class="form-label fw-semibold"><i class="icofont icofont-notepad me-1"></i>Observaciones generales:</label>
                                            <textarea class="form-control" rows="3"
                                                formControlName="observaciones_generales"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Criterios (FormArray dinámico) -->
                            <div class="card border-0 shadow-sm mb-3">
                                <div class="card-header bg-primary"><strong class="text-white">Criterios de
                                        comportamiento</strong></div>
                                <div class="card-body p-0">
                                    <div *ngIf="cargandoCriterios" class="text-center py-4">
                                        <div class="spinner-border text-primary" role="status"></div>
                                    </div>

                                    <div class="table-responsive" *ngIf="!cargandoCriterios" formArrayName="detalle">
                                        <table class="table table-bordered align-middle mb-0">
                                            <thead class="bg-primary">
                                                <tr>
                                                    <th style="width: 25%;">Criterio</th>
                                                    <th class="text-center" style="width: 20%;">Peso</th>
                                                    <th class="text-center" style="width: 10%;">Cumple</th>
                                                    <th class="text-center" style="width: 10%;">Calificación</th>
                                                    <th style="width: 25%;">Observación</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let grupo of detalleArray.controls; let i = index"
                                                    [formGroupName]="i">
                                                    <td>{{ grupo.get('criterio_nombre')?.value }}</td>
                                                    <td class="text-center">{{ grupo.get('peso')?.value ?? '-' }}</td>
                                                    <td class="text-center">
                                                        <div
                                                            class="form-check form-switch d-flex justify-content-center">
                                                            <input class="form-check-input" type="checkbox"
                                                                role="switch" formControlName="cumple">
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <input type="number" min="0" max="100"
                                                            class="form-control form-control-sm"
                                                            formControlName="calificacion">
                                                    </td>
                                                    <td>
                                                        <input type="text" class="form-control form-control-sm"
                                                            formControlName="observacion">
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div *ngIf="!cargandoCriterios && detalleArray.length === 0"
                                        class="text-center py-4 text-primary">
                                        No hay criterios activos. Registra al menos uno en el catálogo de criterios.
                                    </div>
                                </div>
                            </div>

                            <!-- Resultado -->
                            <div class="card border-0 shadow-sm mb-3">
                                <div
                                    class="card-body d-flex justify-content-between align-items-center flex-wrap gap-2">
                                    <div>
                                        <strong><i class="icofont icofont-chart-bar-graph me-1"></i>Resultado global:</strong>
                                        <span class="fs-5 ms-2">{{ resultadoGlobal }}%</span>
                                        <small class="text-secondary ms-2">(umbral de cumplimiento: {{ UMBRAL_CUMPLE
                                            }}%)</small>
                                    </div>
                                    <span class="badge rounded-pill fs-6"
                                        [ngClass]="cumpleGlobal ? 'bg-success' : 'bg-danger'">
                                        {{ cumpleGlobal ? 'CUMPLE' : 'NO CUMPLE' }}
                                    </span>
                                </div>
                            </div>

                            <!-- Plan de refuerzo (solo si no cumple) -->
                            <div class="card border-0 shadow-sm mb-3" *ngIf="!cumpleGlobal">
                                <div
                                    class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
                                    <strong><i class="icofont icofont-tasks-alt me-1"></i>Plan de refuerzo {{ modoEdicion ? '(nuevas acciones)' : '' }}</strong>
                                </div>
                                <div class="card-body" formArrayName="plan_refuerzo">
                                    <div *ngIf="planRefuerzoArray.length === 0" class="text-center py-3 text-primary">
                                        <i class="icofont icofont-info-circle me-1"></i>Agrega al menos una acción de refuerzo.
                                    </div>

                                    <div class="row g-2 mb-2 align-items-end"
                                        *ngFor="let accion of planRefuerzoArray.controls; let i = index"
                                        [formGroupName]="i">
                                        <div class="col-md-5">
                                            <label class="form-label small fw-semibold">Acción</label>
                                            <input type="text" class="form-control" formControlName="accion"
                                                placeholder="Ej. Reinducción en normas de tránsito">
                                        </div>
                                        <div class="col-md-3">
                                            <label class="form-label small fw-semibold">Responsable</label>
                                            <ng-select [items]="colaboradores" bindLabel="nombreCompleto"
                                                bindValue="cedula" [compareWith]="compararPorCedula"
                                                placeholder="Seleccione..." formControlName="responsable">
                                            </ng-select>
                                        </div>
                                        <div class="col-md-3">
                                            <label class="form-label small fw-semibold">Fecha compromiso</label>
                                            <input type="date" class="form-control" formControlName="fecha_compromiso">
                                        </div>
                                        <div class="col-md-1">
                                            <button type="button" class="btn btn-outline-danger btn-sm w-100"
                                                (click)="eliminarAccionRefuerzo(i)">
                                                <i class="icofont icofont-trash"></i>
                                            </button>
                                        </div>
                                    </div>

                                    <small class="text-secondary d-block mt-2" *ngIf="modoEdicion">
                                        <i class="icofont icofont-info-circle me-1"></i>Para marcar cumplimiento de acciones ya registradas, usa el botón de seguimiento
                                        en el listado.
                                    </small>

                                    <div class="d-flex justify-content-center">
                                        <button type="button" class="btn btn-sm btn-outline-primary"
                                            (click)="agregarAccionRefuerzo()">
                                            <i class="icofont icofont-plus"></i> Agregar acción
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="d-flex justify-content-center gap-2 mt-4">
                                <button type="submit" class="btn btn-primary px-4" [disabled]="guardando">
                                    <span *ngIf="!guardando">
                                        <i class="icofont icofont-save me-1"></i>{{ modoEdicion ? 'Actualizar' :
                                        'Guardar' }}
                                    </span>
                                    <span *ngIf="guardando">
                                        <span class="spinner-border spinner-border-sm me-1"></span>
                                        {{ modoEdicion ? 'Actualizando...' : 'Guardando...' }}
                                    </span>
                                </button>
                                <button type="button" class="btn btn-secondary px-4" *ngIf="modoEdicion"
                                    (click)="cancelarEdicion()" [disabled]="guardando">
                                    <i class="icofont icofont-close me-1"></i>Cancelar edición
                                </button>
                            </div>
                        </form>
                    </ng-template>
                </li>

                <!-- ===================== TAB 2: LISTADO ===================== -->
                <li [ngbNavItem]="2">
                    <a ngbNavLink><strong><i class="icofont icofont-listine-dots me-1"></i> LISTADO
                            EVALUACIONES</strong></a>
                    <ng-template ngbNavContent>
                        <div class="card card-absolute rounded mt-3 border-0 shadow-sm">
                            <div class="card-body pt-3">
                                <div *ngIf="cargandoListado" class="text-center py-4">
                                    <div class="spinner-border text-primary" role="status"></div>
                                    <p class="mt-2 mb-0">Cargando evaluaciones...</p>
                                </div>

                                <div class="row mb-3 align-items-center" *ngIf="!cargandoListado">
                                    <div class="col-md-2">
                                        <select class="form-select" [(ngModel)]="filtroEstado"
                                            (change)="aplicarFiltro()">
                                            <option [ngValue]="null">Todos los estados</option>
                                            <option [ngValue]="1">Activos</option>
                                            <option [ngValue]="0">Inactivos</option>
                                        </select>
                                    </div>
                                    <div class="col-md-2">
                                        <input type="number" class="form-control" placeholder="Periodo..."
                                            [(ngModel)]="filtroPeriodo" (input)="aplicarFiltro()">
                                    </div>
                                    <div class="col-md-4 ms-auto">
                                        <div class="input-group">
                                            <span class="input-group-text"><i class="icofont icofont-search-1"></i></span>
                                            <input type="text" class="form-control"
                                                placeholder="Buscar por colaborador..." [(ngModel)]="filtro"
                                                (input)="aplicarFiltro()" />
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="!cargandoListado" class="table-responsive mt-2">
                                    <ng-container *ngIf="evaluacionesFiltradas?.length > 0; else sinDatos">
                                        <table id="tblEvaluacionesComportamiento"
                                            class="table table-bordered table-hover align-middle">
                                            <thead class="bg-primary text-white">
                                                <tr>
                                                    <th class="text-center">N° DOCUMENTO</th>
                                                    <th class="text-center">NOMBRE COLABORADOR</th>
                                                    <th class="text-center">PERIODO</th>
                                                    <th class="text-center">FECHA</th>
                                                    <th class="text-center">RESULTADO</th>
                                                    <th class="text-center">CUMPLE</th>
                                                    <th class="text-center">ESTADO</th>
                                                    <th class="text-center">ACCIONES</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngFor="let item of evaluacionesFiltradas | paginate: { itemsPerPage: pageSize, currentPage: page }">
                                                    <td class="text-center">{{ item.cedula_colaborador }}</td>
                                                    <td class="text-center">{{ item.ColaboradorData?.nombreCompleto }}
                                                    </td>
                                                    <td class="text-center">{{ item.periodo }}</td>
                                                    <td class="text-center">{{ item.fecha_evaluacion | date:
                                                        'dd/MM/yyyy' }}</td>
                                                    <td class="text-center">{{ item.resultado_global }}%</td>
                                                    <td class="text-center">
                                                        <span class="badge rounded-pill"
                                                            [ngClass]="item.cumple ? 'bg-success' : 'bg-danger'">
                                                            {{ item.cumple ? 'SÍ' : 'NO' }}
                                                        </span>
                                                    </td>
                                                    <td class="text-center">
                                                        <span class="badge rounded-pill"
                                                            [ngClass]="Number(item.estado) === 1 ? 'bg-success' : 'bg-secondary'">
                                                            {{ Number(item.estado) === 1 ? 'ACTIVO' : 'INACTIVO' }}
                                                        </span>
                                                    </td>
                                                    <td class="text-center">
                                                        <div class="d-flex justify-content-center gap-1">
                                                            <button
                                                                class="btn btn-sm btn-outline-warning rounded-pill btn-rounded"
                                                                *ngIf="!item.cumple"
                                                                ngbTooltip="Seguimiento plan de refuerzo"
                                                                (click)="verSeguimiento(item)">
                                                                <i class="icofont icofont-tasks-alt"
                                                                    style="font-size: .85rem;"></i>
                                                            </button>
                                                            <button
                                                                class="btn btn-sm btn-outline-primary rounded-pill btn-rounded"
                                                                *ngIf="Number(item.estado) === 1" ngbTooltip="Editar"
                                                                (click)="!cargandoEdicion && editarEvaluacion(item)">
                                                                <i class="icofont icofont-pencil"
                                                                    style="font-size: .85rem;"></i>
                                                            </button>
                                                            <button
                                                                class="btn btn-sm btn-outline-secondary rounded-pill btn-rounded"
                                                                *ngIf="Number(item.estado) === 1" ngbTooltip="Inactivar"
                                                                (click)="cambiarEstado(item, 0)">
                                                                <i class="icofont icofont-close"
                                                                    style="font-size: .85rem;"></i>
                                                            </button>
                                                            <button
                                                                class="btn btn-sm btn-outline-success rounded-pill btn-rounded"
                                                                *ngIf="Number(item.estado) !== 1" ngbTooltip="Activar"
                                                                (click)="cambiarEstado(item, 1)">
                                                                <i class="icofont icofont-check"
                                                                    style="font-size: .85rem;"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <div class="d-flex justify-content-between align-items-center mt-4">
                                            <div class="d-flex align-items-center">
                                                <label class="me-2">Mostrar:</label>
                                                <select class="form-select w-auto" [(ngModel)]="pageSize"
                                                    (change)="page = 1">
                                                    <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{
                                                        size }}</option>
                                                </select>
                                                <span class="ms-2">registros por página</span>
                                            </div>
                                            <div class="text-center flex-grow-1">
                                                Total Registros: <a class="badge badge-primary"><b>{{
                                                        evaluacionesFiltradas?.length || 0 }}</b></a>
                                            </div>
                                            <div class="text-end paginador-personalizado">
                                                <pagination-controls (pageChange)="page = $event" [maxSize]="5"
                                                    [directionLinks]="true" [autoHide]="true" previousLabel="Anterior"
                                                    nextLabel="Siguiente"></pagination-controls>
                                            </div>
                                        </div>

                                        
                                    </ng-container>

                                    <ng-template #sinDatos>
                                        <div class="text-center py-4 text-primary">No hay evaluaciones registradas.
                                        </div>
                                    </ng-template>
                                </div>
                                <div class="mt-4">
                                            <div class="btn-showcase text-center">
                                                <button class="btn btn-outline-success-2x" type="button"
                                                    ngbTooltip="Exportar a Excel"
                                                    (click)="exportarExcel('tblEvaluacionesComportamiento','listado_evaluaciones_comportamiento')">
                                                    <i class="icofont icofont-file-excel"></i> EXCEL
                                                </button>
                                                <button class="btn btn-outline-danger-2x" type="button"
                                                    ngbTooltip="Exportar a PDF"
                                                    (click)="exportToPDF('tblEvaluacionesComportamiento','listado_evaluaciones_comportamiento','Listado de evaluaciones de comportamiento')">
                                                    <i class="icofont icofont-file-pdf"></i> PDF
                                                </button>
                                            </div>
                                        </div>
                            </div>
                        </div>
                    </ng-template>
                </li>
            </ul>

            <div [ngbNavOutlet]="evaluacionTab" class="mt-2"></div>
        </div>
    </div>
</div>

<div class="card border-0 shadow-sm mb-3" *ngIf="resumenColaborador">
    <div class="card-header bg-primary text-white"><strong><i class="icofont icofont-history me-1"></i>Historial del periodo (fuente automática)</strong></div>
    <div class="card-body">
        <div class="row text-center g-3">
            <div class="col-md-3">
                <div class="fs-4 fw-bold"
                    [ngClass]="resumenColaborador.siniestros > 0 ? 'text-danger' : 'text-success'">
                    {{ resumenColaborador.siniestros }}
                </div>
                <small>Siniestros</small>
            </div>
            <div class="col-md-3">
                <div class="fs-4 fw-bold"
                    [ngClass]="resumenColaborador.infracciones > 0 ? 'text-danger' : 'text-success'">
                    {{ resumenColaborador.infracciones }}
                </div>
                <small>Infracciones</small>
            </div>
            <div class="col-md-3">
                <div class="fs-4 fw-bold" [ngClass]="resumenColaborador.quejas > 0 ? 'text-danger' : 'text-success'">
                    {{ resumenColaborador.quejas }}
                </div>
                <small>Quejas</small>
            </div>
            <div class="col-md-3">
                <div class="fs-4 fw-bold">{{ resumenColaborador.capacitaciones?.porcentaje ?? '-' }}%</div>
                <small>Asistencia capacitaciones</small>
            </div>
        </div>
    </div>
</div>